export default __webpack_public_path__ + "static/media/background.ad1abbea.jpg";